var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-image',{style:({ width: _vm.width, height: _vm.height }),attrs:{"src":_vm.url,"preview-src-list":_vm.preSrcList.length?_vm.preSrcList:[_vm.url]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }